import { ref, computed } from 'vue'
import Screen from 'quasar/src/plugins/Screen.js';

export const sidebarState = ref('expanded'); // Possible values: 'expanded', 'collapsed', 'hidden'

export const toggleSidebar = (state) => {
    const isMobile = !Screen.gt.sm

    if (state != 'expanded' && isMobile) {
        sidebarState.value = 'hidden';
        return;
    }

    if (['expanded', 'collapsed', 'hidden'].includes(state)) {
        sidebarState.value = state;
    } else {
        // If no valid state is passed, cycle through the states
        if (sidebarState.value === 'collapsed') {
            sidebarState.value = 'hidden';
        } else if (sidebarState.value === 'hidden') {
            sidebarState.value = 'expanded';
        } else {
            sidebarState.value = 'collapsed';
        }
    }
};

const WIDTHS = { expanded: 290, collapsed: 75, hidden: 0 }

export const sidebarWidth = computed(() => {
    switch (sidebarState.value) {
        case 'expanded':
            return `${WIDTHS.expanded}px`;
        case 'collapsed':
            return `${WIDTHS.collapsed}px`;
        case 'hidden':
            return `${WIDTHS.hidden}px`;
        default:
            return `${WIDTHS.collapsed}px`; // Default to collapsed if state is unknown
    }
});

export const marginLeft = computed(() => {
    const isMobile = !Screen.gt.sm
    switch (sidebarState.value) {
        case 'expanded':
            if (isMobile) {
                return `0px`;
            }
            return `${WIDTHS.expanded}px`;
        case 'collapsed':
            return `${WIDTHS.collapsed}px`;
        case 'hidden':
            return `${WIDTHS.hidden}px`;
        default:
            return `${WIDTHS.collapsed}px`; // Default to collapsed if state is unknown
    }
});

export const sidebarHeight = computed(() => '0px')